import React from 'react';
import { observer } from 'mobx-react';
import { Modal } from 'semantic-ui-react';
import StandardOperations from './StandardOperations';
import StandardOperationList from './StandardOperationList';

export default observer(({ isOpen, onClose, onSelectItem }) => {
  return (
    <Modal size='small' open={isOpen} 
      closeIcon onClose={onClose}
      closeOnDimmerClick={false}>
      <Modal.Header>Select Operation</Modal.Header>
      <Modal.Content style={{ height: '380px' }}>
        <StandardOperations
          fixedHeight={300} 
          onClickItem={onSelectItem} 
          ListComponent={StandardOperationList}
        />
      </Modal.Content>
    </Modal>
  )
})


// WEBPACK FOOTER //
// ./src/components/standard-operations/StandardOperationSelector.js